(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('accordion-custom.accordion-unresolved').forEach(el => {
    const content = el.querySelector('.details-content');
    if (content && content.textContent.trim() !== '') {
      el.classList.remove('accordion-unresolved');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vendor"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-vendor-back]');
    if (!link || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const referrer = document.referrer;
    if (!referrer) return;

    let referrerUrl;
    try {
      referrerUrl = new URL(referrer);
    } catch (error) {
      return;
    }
    if (referrerUrl.origin !== window.location.origin) return;

    const targetPath = (link.getAttribute('data-collection-path') || '')
      .split('?')[0]
      .split('#')[0]
      .replace(/\/+$/, '');
    const referrerPath = referrerUrl.pathname.replace(/\/+$/, '');

    if (targetPath && referrerPath === targetPath) {
      event.preventDefault();
      history.back();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
